var _rect, _rect2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.71875,
    width: 25.999,
    height: 26,
    rx: 12.9995,
    fill: "#26263F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.71875,
    width: 25.999,
    height: 26,
    rx: 12.9995,
    fill: "#2F8AF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9935 19.2889L14.3032 12.63L13.7727 11.8769L10.4175 7.11337L10.1395 6.71875H6.0166L7.02221 8.14683L11.4832 14.4812L12.0137 15.2336L15.5983 20.3231L15.8762 20.7174H19.9992L18.9935 19.2893V19.2889ZM16.366 19.8058L12.642 14.5184L12.1115 13.7657L7.79062 7.63028H9.64943L13.144 12.5921L13.6745 13.3448L18.2251 19.8058H16.3663H16.366Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1114 13.7656L12.6414 14.5184L12.0131 15.2335L7.1894 20.7173H6L11.4827 14.4811L12.1114 13.7656Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5022 6.71875L14.3023 12.63L13.674 13.3448L13.1436 12.5921L13.7722 11.8769L17.2945 7.87085L18.3124 6.71875H19.5022Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXBlue);
export default __webpack_public_path__ + "static/media/x_blue.1da3d097.svg";
export { ForwardRef as ReactComponent };